<template>
    <div class="product-tags">
        <el-tabs style="width: 100%;" v-model="activeProduct_id" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in productList" :key="index" :label="item.product_name" :name="item.id">
                <productdetail :activeProduct_id="activeProduct_id" :objUserInfo="objUserInfo" v-if="item.id == activeProduct_id" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import productdetail from './productdetail.vue';
export default {
    data() {
        return {
            activeProduct_id: '',
            currentPage: 1,
            pageSize: 99,
            productList: [],
            objUserInfo:{},
        };
    },
    methods: {
        handleClick(tab, event) {
            //console.log(tab, event);

        },
        getLoginUser() {
            this.$server.getUser().then(data => {
                if (data.data.code == 0) {
                    this.objUserInfo = data.data;
                }
            });
        },
        getProductList() {
            let param = {
                page: this.currentPage,
                pageCount: this.pageSize
            }
            this.$server.queryProductListByEffective(param).then(data => {
                //console.log("data: " + JSON.stringify(data))
                if (data.data.code == 200) {
                    this.productList = data.data.data.data;
                    //排序
                    this.productList.sort((a, b) => new Date(a.create_time) - new Date(b.create_time));
                    console.log("activeProduct_id: " + this.activeProduct_id);
                    if(this.activeProduct_id == '0'){
                        this.activeProduct_id = this.productList[0].id;
                    }
                    
                }
            })
        },
    },
    components: {
        productdetail,
    },
    created() {
        // 获取 URL 中的查询参数
        var urlParams = new URLSearchParams(window.location.search);
        // 通过参数名获取参数值
        var productId = urlParams.get('product_id');
        console.log("productId: " + productId);
        this.getLoginUser();
        this.activeProduct_id = productId;
        this.getProductList();
    },
    mounted() {
        
    }
};
</script>

<style type="text/css">
.product-tags {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-top: 60px;
}
.el-tabs__header {
    position: fixed;
    width: 100%;
    z-index: 1000;
}
.el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
}

.el-tabs__nav {
    display: flex;
    align-items: center;
    height: 60px;
}

.el-tabs__item {
    color: #797979;
    font-size: 16px;
    padding: 0 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/products/components/products.vue